import React from 'react';
import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const InfoTooltip = withStyles(() => ({
  tooltip: {
    background: '#212121 0% 0% no-repeat padding-box',
    boxShadow: '0px 4px 16px #00000052',
    color: 'white',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontSize: '12px',
    lineHeight: '16px',
    padding: '10px 12px',
    marginTop: 8,
    fontWeight: '400',
    letterSpacing: '0.5px',
    borderRadius: '8px',
  },
}))(Tooltip);

class InfoTooltipWrapper extends React.PureComponent {

    render() {
        const { placement, title, children, width = null, height = null, ...props } = this.props;

        return <InfoTooltip placement={placement} title={title} style={{ width, height }}>{children}</InfoTooltip>;
    }

}

export default InfoTooltipWrapper;
